/**
 * React Query hook for the Code Signing & AV screen.
 *
 * Polling cadence: 5 minutes — cert state and VirusTotal verdicts change
 * slowly. Matches the setInterval cadence in the source view.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchCodeSigning } from '@/api/codeSigning';

export function useCodeSigning() {
  return useQuery({
    queryKey: ['adminCodeSigning'],
    queryFn: fetchCodeSigning,
    refetchInterval: 5 * 60_000
  });
}
